// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n[data-v-d896e6d0] .van-overlay {\n  background-color: rgba(0, 0, 0, 0);\n}\n.van-popup[data-v-d896e6d0] {\n  background: rgba(0, 0, 0, 0.6);\n  width: 2.66667rem;\n  height: 1.6rem;\n  border-radius: 0.53333rem;\n  padding: 0.4rem;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n}\n", ""]);
// Exports
module.exports = exports;
